import { useEffect, useMemo, useRef, useCallback } from 'react'
import { BaseChatPackage, isMaxMentionsReached } from "../utils"
import { alert } from '@codeleap/modals'
import { Constants } from '../constants'

type Mention = { id: string; name: string }
export class UseMentionsLimit extends BaseChatPackage {
  useMentionsLimit(mentions: Mention[], text: string, debounceDelay: number = 300) {
    const debounceTimerRef = useRef<NodeJS.Timeout | null>(null)
    const lastAlertedRef = useRef(false)

    const checkMentionsLimit = useCallback(() => {
      const maxMentionsReached = isMaxMentionsReached(mentions, text)

      if (maxMentionsReached && !lastAlertedRef.current) {
        alert.error({
          title: 'Mentions Limit Reached',
          body: `You can only mention up to ${Constants.maxMentions} users in a message.`,
        })
        lastAlertedRef.current = true
      } else if (!maxMentionsReached && lastAlertedRef.current) {
        lastAlertedRef.current = false
      }

      return maxMentionsReached
    }, [mentions, text])

    const maxMentionsReached = useMemo(() => {
      return isMaxMentionsReached(mentions, text)
    }, [mentions, text])

    useEffect(() => {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current)
      }

      debounceTimerRef.current = setTimeout(() => {
        checkMentionsLimit()
      }, debounceDelay)

      return () => {
        if (debounceTimerRef.current) {
          clearTimeout(debounceTimerRef.current)
        }
      }
    }, [text, checkMentionsLimit, debounceDelay])

    return { maxMentionsReached }
  }
}

